<template>
  <div class="text-center col-md-12">
    <!-- <inline-svg src="/media/svg/school/undraw_empty.svg" class="max-w-400px" /> -->
  </div>
</template>
